import React from 'react';
import styled from 'styled-components';
import Footer from './Footer';
import NavBar from './NavBar';
import AdInterstitial from './AdInterstitial';

const LayoutWrapper = styled.div`
  max-width: 100vw;
  overflow-x: hidden;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--bg);
  font-family: 'Inter', Arial, Helvetica, sans-serif;
  transition: background 0.2s;
`;

const Main = styled.main`
  flex: 1;
`;

const Layout = (props) => (
  <LayoutWrapper className={props.className}>
    <AdInterstitial />
    <NavBar />
    <Main>
      {props.children}
    </Main>
    <Footer />
  </LayoutWrapper>
);

export default Layout;
